import React, { useState } from 'react';
import { useNavigate } from "react-router";
import { apiService } from '../services/apiService';
import AuthBanner from './AuthBanner';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

const Login = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');

  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = location.state?.successMessage; // Retrieve success message from state


  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const validateForm=()=>{
    const newErrors = {};
  
    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Invalid email address";
    }
    if (!password.trim()) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log({ email, password });
      try {
        const response = await apiService("auth/login", "POST", { email, password });
        const { token } = response.data;
        localStorage.setItem("authToken", token);
        console.log("Login successful:", token);
        navigate("/actual-sales");
      } catch (error) {
        console.log("Login error:", error.response);
        setServerError(error.message || "Login failed" );
      }
    
    }
  };
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Left Section (Banner + Text) */}
      <AuthBanner />

      {/* Right Section (Login Form) */}
      <div className="md:w-1/3 w-full flex items-center justify-center bg-white">
        {/*
          We use flex-col + justify-between on this container so the
          "Powered by" text can be pushed to the bottom if desired.
        */}
        <div className="w-full max-w-sm p-6 flex flex-col justify-between min-h-[500px] ">
          <div>
            {/* Toshiba Logo */}
            <div className="flex justify-between mb-4">
              <div className="text-3xl font-bold text-red-600">TOSHIBA</div>
            </div>

            {/* Login Header */}
            <h2 className="text-2xl font-semibold text-[#000] mb-6">Login</h2>
            {serverError && (
              <div className="mb-4 text-red-500 text-sm text-center">
                {serverError}
              </div>
            )}
             {/* Display success message if it exists */}
              {successMessage && (
                <div className="mb-4 text-green-500 text-sm text-center">
                  {successMessage}
                </div>
              )}

            {/* Login Form */}
            <form onSubmitCapture={handleSubmit} className="flex flex-col">
              <div className="mb-4">
                <label htmlFor="email" className="block text-sm text-[#000] pb-1 ">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter Email Address"
                  
                  className={`w-full p-2 border border-[#6E757C] rounded-sm ${
                    errors.email ? "border-red-500" : "border-[#6E757C]"
                  }`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                 {errors.email && (
                  <p className="text-red-500 text-xs mt-3 pt-2">{errors.email}</p>
                )}
              </div>

              <div className="mb-4 ">
                <label htmlFor="password" className="block text-sm text-[#000] pb-1">
                  Password
                </label>
                <div className='relative'>
                  <input
                    type={isPasswordVisible ? 'text' : 'password'}  // Toggle type between text and password
                    id="password"
                    name="password"
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={`w-full p-2 border border-[#6E757C] rounded-sm pr-10  ${
                      errors.password ? "border-red-500" : "border-[#6E757C]"
                    }`}  // Added pr-10 for padding right
                  />
                  {/* Eye icon for toggling password visibility */}
                  {/* <img
                    src='/images/eye.png'
                    alt='view password'
                    className="absolute right-2  top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibility}
                  /> */}
                 <span
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-700"
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                </span>
                </div>
                {errors.password && (
                  <p className="text-red-500 text-xs mt-3 pt-2">{errors.password}</p>
                )}
              </div>

              <div className="text-right  mb-4">
                {/* <a href="#" className="text-sm text-[#000] hover:text-[#000] cursor-pointer underline ">
                  Forgot password
                </a> */}
                <Link to="/forgot-password" className="text-sm text-[#000] hover:text-[#000] cursor-pointer underline">
                  Forgot password ?
                </Link>
              </div>

              <div className="flex items-center justify-between mb-2">
                <button
                  type="submit"
                  className="bg-[#3D3D3D] text-white py-2 px-6 rounded-sm w-full"
                 
                >
                  <span className='text-white text-sm cursor-pointer'>Log In</span>
                </button>
              </div>

            </form>
          </div>

          {/* Footer at the Bottom of the Form */}
          <div className="text-xs text-[#000] mt-6 text-center">
            Powered by Sparsh Communications Pvt. Ltd.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
